(function () {
  'use strict';
  angular.module('dso')
    .component('providerContact', {
        bindings: {
          model: '=',
          readOnly: '@'
        },
        controller: function() {
          var ctrl = this;
        },
        templateUrl: 'js/dso/providerContact.html' + appVersion
      }
    );
})();
